import React from 'react';
import { DecisionFlow, ReturnInspectionRule } from '../../types/returnInspection';
import { contentStageReachable } from './decisionFlow';
import { ModeBadge } from './ruleDisplay';

/** 一条规则的简要展示：处理方式，以及"按流程初检"模式下的基准资料概况 */
const RuleSummary: React.FC<{ rule: ReturnInspectionRule }> = ({ rule }) => {
  const flow = rule.decision_flow as DecisionFlow;
  const checksContent = rule.mode === 'conditional' && !!flow?.appearance_ok && contentStageReachable(flow);
  return (
    <div>
      <div>
        <ModeBadge mode={rule.mode} bold />
      </div>
      {rule.mode === 'conditional' && (
        <div style={{ marginTop: 4, color: '#666', fontSize: 12 }}>
          外观基准照片 {rule.packaging_baseline_photos.length} 张
          {checksContent &&
            ` · 内件物品清单 ${rule.content_checklist.length} 项、内件照片 ${rule.content_baseline_photos.length} 张`}
        </div>
      )}
    </div>
  );
};

export default RuleSummary;
